import React, { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import PsContext from "../../context";
import { MOB_ICONS } from "../../utils";
import Header from "../header";
import { Col, Row } from "react-bootstrap";

const NotFound = (props) => {
  const context = useContext(PsContext);
  const navigation = useNavigate();

  const [loader, setLoader] = useState(false);

  const goToHome = () => {
    let r =
      context.getStorage("login_by") == "staff" ? "/staff/app" : "/stu/app";
    navigation(r);
  };

  return (
    <>
      <Header
        backAction={true}
        title="Not Found"
        rightActions={[]}
        onBack={(e) => goToHome()}
      />
      <div className="">
        <div className="container-sm py-4">
          <section className="top-space px-3">
            <Row>
              <Col md={{ span: 6, offset: 3 }}>
                <div class="empty-cart-section text-center">
                  <img
                    src={MOB_ICONS.NOTFOUND_256}
                    style={{ width: "150px" }}
                  />
                  <div className="fs-5 py-3">Sorry !! something went wrong</div>

                  <a
                    onClick={(e) => goToHome()}
                    class="btn bg-theme w-100 mt-3"
                  >
                    Go to Dashboard
                  </a>
                </div>
              </Col>
            </Row>
          </section>
        </div>
      </div>
    </>
  );
};
export default NotFound;
